import React, { useEffect } from 'react';

/**
 * AFKModal — "Still there?" prompt shown after a long stretch of input
 * inactivity. Clicking "I'm here" dismisses; "Log out" calls onLogout.
 * Auto-times-out via the hook (see useAFKDetection.onTimeout).
 */
function AFKModal({ secondsLeft, onStay, onLogout }) {
  // Block scroll + Esc closes (treat as "stay")
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onStay(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onStay]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.75)',
        zIndex: 11000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onStay}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: 'min(420px, 90vw)',
          padding: '22px 24px',
          background: 'linear-gradient(180deg, #1a2438 0%, #131826 100%)',
          border: '1px solid #4a6a90',
          borderRadius: 10,
          boxShadow: '0 8px 32px rgba(0,0,0,0.6)',
          color: '#dde8f5',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: 36, marginBottom: 8 }}>😴</div>
        <h2 style={{ margin: '0 0 8px', color: '#9fdcf7' }}>Still there?</h2>
        <p style={{ margin: '0 0 6px', fontSize: 14, color: '#b8c8dc' }}>
          You've been idle for a while. We'll log you out automatically to free up the realm.
        </p>
        <p style={{ margin: '0 0 16px', fontSize: 13, color: '#8aa0bb' }}>
          Auto-logout in <strong style={{ color: '#ffd96b' }}>{secondsLeft}s</strong>
        </p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <button
            onClick={onStay}
            style={{
              padding: '10px 18px',
              background: 'linear-gradient(180deg, #2a6a3a, #1a4a2a)',
              border: '1px solid #4a8a4a',
              color: '#d8f5d8',
              borderRadius: 6,
              cursor: 'pointer',
              fontWeight: 600,
            }}
          >I'm here!</button>
          <button
            onClick={onLogout}
            style={{
              padding: '10px 18px',
              background: 'rgba(120,60,60,0.35)',
              border: '1px solid #a04040',
              color: '#ffb8b8',
              borderRadius: 6,
              cursor: 'pointer',
            }}
          >Log out</button>
        </div>
      </div>
    </div>
  );
}

export default AFKModal;
